export const COPY_INVOICE_TITLE: string = 'Copy cancelled invoice';
export const COPY_INVOICE_PLACEHOLDER: string = 'Enter easybill document id';

export const COPY_INVOICE_SUBMIT_TEXT: string = 'Copy';
export const COPIED_TO_CLIPBOARD: string = 'Invoice Link is opened in a new tab\
 and copied to clipboard';
